
























import { Component, Vue, Watch } from "vue-property-decorator";
import { ClientGrantType } from "../../../../types/client";
import { SaveMixin } from "@/services/mixins/saveMixin";
import { required, maxLength } from "vuelidate/lib/validators";
import { HttpService } from "../../../../services/api/httpService";
@Component({
  mixins: [SaveMixin],
  validations: {
    clientGrantType: {
      grantType: { required, maxLength: maxLength(250) }
    }
  }
})
export default class ClientGrantTypeSave extends Vue {
  clientGrantType = new ClientGrantType();
  httpService = new HttpService<ClientGrantType>();
  showData = false;
  backRoute = {
    name: "clientDashboard",
    id: ""
  };

  async created() {
    if (this.$route.params.grantTypeId) {
      const response = await this.httpService.getItem(
        `clients/${this.$route.params.id}/grant-types/${this.$route.params.grantTypeId}`
      );

      this.clientGrantType = response.data || new ClientGrantType();
    }
    this.clientGrantType.clientId = Number(this.$route.params.id);
    this.backRoute.id = this.$route.params.id;
    this.showData = true;
  }

  async save() {
    this.$store.commit("SAVE", false);
    this.$v.$touch();

    if (!this.$v.$invalid) {
      let save = "";
      this.clientGrantType.id
        ? await this.httpService.putItem(
            `clients/${this.clientGrantType.clientId}/grant-types/${this.clientGrantType.id}`,
            this.clientGrantType
          )
        : await this.httpService.postItem(
            `clients/${this.clientGrantType.clientId}/grant-types`,
            this.clientGrantType
          );
      this.$notification.success("Client Grant Type successfully saved");
      this.$router.push(this.backRoute);
      this.$store.dispatch("SET_DIRTY", false);
    }
  }
}
